"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncImportIcon = asyncImportIcon;
exports["default"] = void 0;

var _iconEnum = _interopRequireDefault(require("./concat/icon-enum"));

var icons = _interopRequireWildcard(require("./concat/icons"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import { iconEnum } from './asset/icon-enum';
// import * as icons from './icons/index';
function asyncImportIcon(enumKey) {
  return new Promise(function (resolve, reject) {
    var isNumber = typeof enumKey === 'number';
    var errorMsg = "\u3010".concat(isNumber ? enumKey : "\"".concat(enumKey, "\""), "\u3011\u5728\u56FE\u6807\u5E93\u627E\u4E0D\u5230\u5BF9\u5E94\u56FE\u6807");

    var _enumKey = isNumber ? _iconEnum["default"][enumKey] : enumKey;

    if (!_iconEnum["default"].includes(_enumKey)) {
      reject(errorMsg);
      return;
    }

    var icon = icons["Icon".concat(_enumKey)];

    if (icon) {
      resolve(icon);
    } else {
      reject(errorMsg);
    } // import(`./icons/${icon}`)
    //   .then((data) => {
    //     resolve(data.default);
    //   })
    //   .catch((error) => {
    //     reject(error);
    //   });

  });
}

var _default = asyncImportIcon;
exports["default"] = _default;